//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vuexMixin from "@/lib/vuexMixin"
import globalMixin from "@/lib/global"

export default {
  mixins: [vuexMixin, globalMixin],
  data() {
    return {
      notAccepetedCookies: false
    }
  },
  created(){
  this.watchingAccepetedCookies()
  },
  watch:{
    isSolicitation(newVlue, oldValue){
      const value1 = newVlue
      const value2 = oldValue
      if (value1 != value2){
        this.watchingAccepetedCookies()
      }
    }
  },
  methods: {
    watchingAccepetedCookies(){
      this.notAccepetedCookies = this.needAcceptCookies()
      if (!this.notAccepetedCookies && this.getToken) {
        this.hasLogin(this.getAuth)
      }
    },
    acceptCookies() {
      this.notAccepetedCookies = false;
      const lastVersionCookeis = this.getItemNoCoockie('lastVersionCookeis')
      const jwt = require("jsonwebtoken");
      this.$cookiz.set(`lastVersionCookeis`, jwt.sign('accepted',process.env.COOCKIES_SECRET_KEY) , {path: '/',
        maxAge: 60 * 60 * 24 * 7} )
      if(this.getToken){
        this.hasLogin(this.getAuth)
      }
    },
    openTerms(type) {
      let route = this.$router.resolve({
        path: "termsPolicy"
      })
      if(type === "terms") this.setRegisterTab(0)
      else this.setRegisterTab(1)
      window.open(`${route.href}?type=${type}`, "_blank")
      },
  },

}

